import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_468: DocMigration = {
  maxSchemaVersion: "0.0.468",
  description: "Update PropMaterialOverrides to include useExteriorPalette",
  apply(json: any) {
    const { propAttributes, propInstances } = json;

    const propAttributesIds = Object.keys(propAttributes);
    for (const propAttributeId of propAttributesIds) {
      const propAttribute = propAttributes[propAttributeId];
      if (propAttribute.materialOverrides) {
        for (const materialKey in propAttribute.materialOverrides) {
          const paletteMaterialSlot = propAttribute.materialOverrides[materialKey];
          propAttribute.materialOverrides[materialKey] = {
            paletteMaterialSlot,
            useExteriorPalette: propAttribute.useExteriorPalette,
          };
        }
      }
    }

    const propInstancesIds = Object.keys(propInstances);
    for (const propInstanceId of propInstancesIds) {
      const propInstance = propInstances[propInstanceId];
      if (propInstance.materialOverrides) {
        for (const materialKey in propInstance.materialOverrides) {
          const paletteMaterialSlot = propInstance.materialOverrides[materialKey];
          propInstance.materialOverrides[materialKey] = {
            paletteMaterialSlot,
            useExteriorPalette: propInstance.useExteriorPalette,
          };
        }
      }
    }

    return json;
  },
};

export default migration_0_0_468;
